import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { showChatWithMessage } from 'Services/chat';
import EventService from 'Services/events';
import { userAuthSelector } from 'Store/modules/auth/selectors';
import LandBot from 'Components/LandBot';
import OneColLayout from 'Components/Layouts/OneColLayout';
import { LANDBOT_ID, TAX_YEAR } from 'Config';
import { DgLandBotEventType } from './types';

const DgLandBot = (): JSX.Element => {
  const { id: userId } = useSelector(userAuthSelector);
  useEffect(() => {
    const handleMessage = (event): void => {
      if (event.data.type === DgLandBotEventType.LANDBOT_INTERCOM && event.data.data.hasIntercom) {
        showChatWithMessage({ message: event.data.data.message });
        EventService.dataGatheringHelp({ userId, taxYear: TAX_YEAR, ...event.data.data.event });
      }
      if (event.data.type === DgLandBotEventType.LANDBOT_SAT_ID && event.data.data.hasSatId) {
        EventService.dataGatheringHelp({ userId, taxYear: TAX_YEAR, ...event.data.data.event });
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
  return (
    <OneColLayout>
      <LandBot url={`https://storage.googleapis.com/landbot.pro/v3/${LANDBOT_ID}/index.json`} />
    </OneColLayout>
  );
};

export default DgLandBot;
